import React, { useCallback, useEffect, useMemo } from 'react'
import { deleteCookie, inIframe, usePathParam } from '@chilecompra/react-kit'
import { LinkButton } from '@chilecompra/react-kit/components'
import { REACT_APP_BASE_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import { PATH_PARAM } from '../config/settings/regexes'
import routes from '../config/settings/routes'
import AuthorizationContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import HeaderContainer from '../containers/Header/Header.container'
import HeadingSectionContainer from '../containers/HeadingSection/HeadingSection.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import NotFoundPage from './NotFound'
import HistoricalContracts from '../containers/HistoricalContracts/HistoricalContracts.container'

/**
 * The Historical Contract's page.
 */
const HistoricalContract = () => {
  const title = 'Contratos históricos'
  const dni = usePathParam('rut')

  const breadcrumbs = useCallback(userType => {
    return [
      {
        text: 'Escritorio',
        link: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
        isExternal: true,
        onClick: handleClickHome
      },
      userType !== 'Proveedor' && {
        text: 'Búsqueda Proveedor',
        link: `${REACT_APP_BASE_URL}/busqueda`,
        isExternal: true
      },
      {
        text: dni,
        link: routes.contractualBehavior.replace(PATH_PARAM, dni),
        isExternal: false
      },
      {
        text: 'Historico'
      }
    ].filter(Boolean)
  }, [])

  const handleClickHome = event => {
    event.preventDefault()
    deleteCookie('access_token')
    window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
  }

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  useEffect(() => {
    if (isInIframe) {
      window.parent.postMessage(
        {
          action: 'scrollTo',
          value: {
            x: 0,
            y: 0
          }
        },
        REACT_APP_MERCADO_PUBLICO_BASE_URL
      )
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  return (
    <ProtectByFeatures rule={features => features['com.seller/contractual.behavior']} fallback={() => <NotFoundPage />}>
      <AuthorizationProviderContainer>
        <AuthorizationContext.Consumer>
          {({ userType }) => (
            <ProtectByProfile
              rule={userType => userType === 'Comprador' || userType === 'Proveedor'}
              fallback={() => <NotFoundPage />}
            >
              <BrandLayout
                featured={<HeadingSectionContainer breadcrumbs={breadcrumbs(userType)} title={title} />}
                header={<HeaderContainer />}
              >
                <HistoricalContracts />

                <LinkButton
                  to={routes.contractualBehavior.replace(PATH_PARAM, dni)}
                  color="default"
                  margin="2rem 0 0"
                  variant="outlined"
                >
                  Volver
                </LinkButton>
              </BrandLayout>
            </ProtectByProfile>
          )}
        </AuthorizationContext.Consumer>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}

export default HistoricalContract
